import { RawAxiosRequestHeaders } from 'axios'

interface Props {
  varitiToken?: string
  hmacToken?: string
}

/**
 * Функция, которая возвращает единый header для v3 и v4 axios config-ов
 * @param varitiToken - токен, для пропуска api запросов
 * @param hmacToken - токен, для пропуска api сервиса адресов
 */
export const getAxiosGlobalHeader = ({
  varitiToken,
  hmacToken,
}: Props): RawAxiosRequestHeaders => {
  // Добавляем header только в случае, если он не пустой
  return {
    ...(varitiToken && { 'X-Dev-STkn': varitiToken }),
    ...(hmacToken && { 'X-SA-site': hmacToken }),
  }
}
